/**
 * 계층 2 — 어댑터 인터페이스. TV2M 모바일 SDK 의 경계 계약이다.
 *
 * `packages/bloom-receiver-sdk/src/adapters/interfaces.ts` 와 같은 자리이고 같은 이유로 존재한다:
 * **이 파일이 DOM·ServiceWorker 를 참조하면 코어가 그것을 소비할 수 없다.**
 * 그래서 `tsconfig.core.json`(`lib: ES2022`, `types: []`)이 이 파일까지 담는다 —
 * `PushSubscription`·`ServiceWorkerRegistration` 같은 웹 전용 타입이 계약에 새면
 * 즉시 타입 에러다 (CLAUDE.md 절대 규칙 13).
 *
 * 계약에 쓰는 타입은 전부 `@apm/contracts` 에서 온다. 여기서 재선언하지 않는다 (절대 규칙 10).
 *
 * > **`docs/09` T6 의 어댑터 목록을 개정했다.** 원안은 넷(`PushAdapter`·`StorageAdapter`·
 * > `NetworkAdapter`·`NotificationAdapter`)이었는데 `EnvironmentAdapter` 가 빠져 있다.
 * > 같은 문서가 "`device_id` 생성은 어댑터가 한다 (코어에 `crypto.randomUUID` 가 없다)" 고
 * > 적어 두고 그 어댑터를 지목하지 않았고, Deferred Link 의 지문 재료(UA·language·
 * > timezone·screen)도 코어가 스스로 알 수 없다. 넷 중 아무 데나 밀어 넣으면 그 어댑터의
 * > 이름이 거짓이 되므로 다섯 번째를 둔다.
 */
/**
 * HTTP 실패. **상태 코드를 코어까지 올려 보내기 위해 존재한다.**
 *
 * 코어가 구분해야 하는 상태가 실제로 있다 — `POST /v1/device/heartbeat` 의 404 는
 * "등록되지 않은 기기" 라서(T2) 재등록으로 회복할 수 있는데, 문자열 메시지만 오면
 * 그것을 네트워크 단절과 구분할 수 없어 앱이 영원히 404 를 두드린다.
 *
 * 어댑터가 아니라 이 파일에 두는 이유는 코어가 `instanceof` 로 검사해야 해서다.
 * 웹 전용 타입을 참조하지 않으므로 `tsconfig.core.json` 아래에 있어도 된다.
 */
export class Tv2mHttpError extends Error {
    status;
    constructor(status, message) {
        super(message);
        this.status = status;
        this.name = 'Tv2mHttpError';
    }
}
/**
 * 알림 권한 상태. 웹의 `NotificationPermission` 과 값이 겹치지만 **같은 타입이 아니다** —
 * 그 타입은 DOM lib 에 있어 코어가 참조할 수 없고, `unsupported` 가 없다.
 *
 * `unsupported` 를 `denied` 와 구분하는 이유: iOS 가 A2HS 로 설치되기 전에는 Push API 자체가
 * 없는데(WB-08), 이것을 "거부됨" 으로 뭉개면 화면이 "알림을 켜 주세요" 를 띄운다. 사용자가
 * 켤 수 있는 스위치가 없는 상태라 안내해야 하는 것은 **홈 화면에 추가하라**는 것이다.
 */
export const PUSH_PERMISSIONS = ['granted', 'denied', 'default', 'unsupported'];
//# sourceMappingURL=interfaces.js.map